import { createAction } from '@reduxjs/toolkit';

export const setSelectedProjectId = createAction(
  'project/setSelectedProjectId'
);

export const setMobileShowList = createAction('project/setMobileShowList');

export const setSelectedFolder = createAction('project/setSelectedFolder');

export const toggleShowAll = createAction('project/toggleShowAll');

export const toggleShowShortTermProjects = createAction(
  'project/toggleShowShortTermProjects'
);

export const toggleOpenSelectAssignmentDialog = createAction(
  'project/toggleOpenSelectAssignmentDialog'
);

export const setSelectedShortTermProjectsViewMode = createAction(
  'project/setSelectedShortTermProjectsViewMode'
);
